import { useQuery } from "@tanstack/react-query";
import { promotionApi } from "../services/promotion.api";
import { PromotionFilterType } from "../../../interfaces/promotionType";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UsePromotionsQueryParams = {
  filter: PromotionFilterType;
  pagination: IApiPagination;
};

export const usePromotionsQuery = (params: UsePromotionsQueryParams) => {
  return useQuery({
    queryKey: ["promotions", params],
    queryFn: async () => {
      const res = await promotionApi.getPromotions(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const usePromotionByIdQuery = (id: string) => {
  return useQuery({
    queryKey: ["promotion-by-id", id],
    queryFn: () => promotionApi.getPromotionById(id),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!id,
  });
};
